<script setup lang="ts">
import TBase from './TBase.vue';
import type { TypographyBaseProps } from './types';

defineOptions({
  name: 'CustomH3',
});

const props = withDefaults(defineProps<TypographyBaseProps>(), {
  fontFamily: 'BMWGroupTNC',
  size: 32,
  color: 'inherit',
  weight: 700,
  onClick: undefined,
});
</script>

<template>
  <TBase v-bind="props">
    <slot />
  </TBase>
</template>
